export default {
  getCompleteDataFailed: 'Sorry, we could not retrieve the message. Try again',
};
